/**
 * Learn library — filter, search, load-more, URL sync.
 * v3.0.0 — loops inlined in section; index from paginate.items in same scope.
 */
(function () {
  'use strict';

  var PAGE_SIZE = 12;
  var LIBRARY_VERSION = '3.2.0';

  function articleId(value) {
    return value == null ? '' : String(value);
  }

  function parseConfig(section) {
    var node = section.querySelector('[data-learn-config]');
    if (!node) return { parseError: 'missing-config-node', articles: [] };
    try {
      var config = JSON.parse(node.textContent);
      config._liquidIndexCount = parseInt(node.getAttribute('data-learn-index-count') || '0', 10);
      return config;
    } catch (e) {
      return { parseError: String(e), articles: [] };
    }
  }

  function normalizeQuery(value) {
    return (value || '').trim().toLowerCase();
  }

  function topicLabel(config, handle) {
    var topics = config.topics || [];
    for (var i = 0; i < topics.length; i++) {
      if (topics[i].handle === handle) return topics[i].label;
    }
    return handle;
  }

  function cardCategoryLabel(article, config) {
    if (article.categoryLabel) return article.categoryLabel;
    if (article.topics && article.topics.length) {
      return topicLabel(config, article.topics[0]);
    }
    return '';
  }

  function buildSearchHaystack(article, config) {
    var parts = [article.title, article.excerpt, article.dek];
    (article.topics || []).forEach(function (h) {
      parts.push(h);
      parts.push(topicLabel(config, h));
    });
    (article.tags || []).forEach(function (t) {
      parts.push(t);
    });
    return normalizeQuery(parts.join(' '));
  }

  function readUrlState() {
    var params = new URLSearchParams(window.location.search);
    return {
      topic: params.get('topic') || 'all',
      q: params.get('q') || ''
    };
  }

  function writeUrlState(topic, q, replace) {
    var params = new URLSearchParams(window.location.search);
    if (!topic || topic === 'all') {
      params.delete('topic');
    } else {
      params.set('topic', topic);
    }
    if (!q) {
      params.delete('q');
    } else {
      params.set('q', q);
    }
    var query = params.toString();
    var next = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    var current = window.location.pathname + window.location.search + window.location.hash;
    if (next === current) return;
    if (replace) {
      window.history.replaceState({ learnTopic: topic, learnQ: q }, '', next);
    } else {
      window.history.pushState({ learnTopic: topic, learnQ: q }, '', next);
    }
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderCard(article, config, labels) {
    var category = cardCategoryLabel(article, config);
    var dateHtml =
      labels.showDates && article.publishedAt
        ? '<p class="known-learn__date">' + escapeHtml(article.publishedAt) + '</p>'
        : '';
    var topicHtml =
      labels.showTags && category
        ? '<p class="known-learn__topic">' + escapeHtml(category) + '</p>'
        : '';
    var excerptHtml = article.excerpt
      ? '<p class="known-learn__excerpt">' + escapeHtml(article.excerpt) + '</p>'
      : '';
    var imgHtml = article.imageUrl
      ? '<img class="known-learn__mini-image" src="' +
        escapeHtml(article.imageUrl) +
        '" alt="' +
        escapeHtml(article.imageAlt || article.title) +
        '" loading="lazy" width="720" height="480">'
      : '<div class="known-learn__mini-image known-learn__image-fallback" aria-hidden="true"></div>';

    return (
      '<article class="known-learn__mini-card known-learn__library-card" data-learn-card data-article-id="' +
      article.id +
      '">' +
      '<a href="' +
      escapeHtml(article.url) +
      '" class="known-learn__mini-image-link" aria-label="' +
      escapeHtml(article.title) +
      '">' +
      imgHtml +
      '</a>' +
      '<div class="known-learn__mini-content">' +
      topicHtml +
      '<h3><a href="' +
      escapeHtml(article.url) +
      '">' +
      escapeHtml(article.title) +
      '</a></h3>' +
      dateHtml +
      excerptHtml +
      '<a class="known-learn__read-link known-learn__read-link--small" href="' +
      escapeHtml(article.url) +
      '">' +
      escapeHtml(labels.readMore) +
      ' <span aria-hidden="true">→</span></a>' +
      '</div></article>'
    );
  }

  function domDiag(section) {
    var grid = section ? section.querySelector('[data-learn-grid]') : null;
    var cfgNode = section ? section.querySelector('[data-learn-config]') : null;
    var parsedCount = 0;
    var parseError = null;
    if (cfgNode) {
      try {
        parsedCount = JSON.parse(cfgNode.textContent).articles.length;
      } catch (e) {
        parseError = String(e);
      }
    }
    return {
      version: LIBRARY_VERSION,
      previewThemeId: new URLSearchParams(window.location.search).get('preview_theme_id'),
      sectionId: section ? section.getAttribute('data-learn-section-id') : null,
      sectionVersion: section ? section.getAttribute('data-learn-library-version') : null,
      blogHandle: section ? section.getAttribute('data-learn-blog-handle') : null,
      blogTotal: section ? section.getAttribute('data-learn-blog-total') : null,
      liquidIndexCount: cfgNode ? cfgNode.getAttribute('data-learn-index-count') : null,
      parsedIndexCount: parsedCount,
      parseError: parseError,
      ssrCardCount: grid ? grid.querySelectorAll('[data-learn-ssr]').length : 0,
      visibleSsrCount: grid
        ? Array.prototype.filter.call(grid.querySelectorAll('[data-learn-ssr]'), function (c) {
            return !c.hidden && !c.classList.contains('is-hidden');
          }).length
        : 0,
      libraryRoots: document.querySelectorAll('.known-learn[data-learn-library]').length,
      scriptSrc: (function () {
        var s = document.querySelector('script[src*="learn-library.js"]');
        return s ? s.src : null;
      })(),
      initialized: !!(section && section._learnInitialized),
      searchListener: !!(section && section._learnSearchListener),
      filterListenerCount: section ? section._learnFilterListenerCount || 0 : 0,
      popular: section
        ? Array.prototype.map.call(section.querySelectorAll('[data-learn-popular-card]'), function (card) {
            return {
              slot: card.getAttribute('data-popular-slot'),
              handle: card.getAttribute('data-popular-handle'),
              title: card.querySelector('h3') ? card.querySelector('h3').textContent.trim() : null,
              hidden: card.hidden
            };
          })
        : [],
      activeTopic: section ? section._learnActiveTopic : null,
      activeQuery: section ? section._learnActiveQuery : null,
      filteredCount: section ? section._learnFilteredCount : null
    };
  }

  window.learnLibraryDiag = function () {
    var sections = document.querySelectorAll('.known-learn[data-learn-library]');
    if (!sections.length) return [domDiag(null)];
    return Array.prototype.map.call(sections, domDiag);
  };

  function initSection(section) {
    var rawConfig = parseConfig(section);
    var grid = section.querySelector('[data-learn-grid]');
    var featuredRow = section.querySelector('[data-learn-featured]');
    var searchInput = section.querySelector('[data-learn-search]');
    var filterButtons = section.querySelectorAll('[data-learn-filter]');
    var loadMoreBtn = section.querySelector('[data-learn-load-more]');
    var emptyState = section.querySelector('[data-learn-empty]');
    var resetBtn = section.querySelector('[data-learn-reset]');
    var statusEl = section.querySelector('[data-learn-status]');

    if (!grid) return;

    section._learnInitialized = true;
    section._learnFilterListenerCount = filterButtons.length;

    var labels = {
      readMore: section.getAttribute('data-read-more-label') || 'Read more',
      showTags: section.getAttribute('data-show-tags') !== 'false',
      showDates: section.getAttribute('data-show-dates') !== 'false'
    };

    var featuredId = featuredRow ? articleId(featuredRow.getAttribute('data-featured-id')) : '';
    var indexReady = !rawConfig.parseError && rawConfig.articles && rawConfig.articles.length > 0;
    var config = indexReady ? rawConfig : { articles: [], topics: rawConfig.topics || [] };

    var articles = config.articles.map(function (a) {
      a.id = articleId(a.id);
      a.topics = Array.isArray(a.topics) ? a.topics : [];
      a.tags = Array.isArray(a.tags) ? a.tags : [];
      a._haystack = buildSearchHaystack(a, config);
      return a;
    });

    var activeTopic = readUrlState().topic;
    var activeQuery = readUrlState().q;
    var visibleLimit = PAGE_SIZE;

    section._learnActiveTopic = activeTopic;
    section._learnActiveQuery = activeQuery;

    if (searchInput) searchInput.value = activeQuery;

    function setFilterPressed(topic) {
      filterButtons.forEach(function (btn) {
        var isActive = btn.getAttribute('data-learn-filter') === topic;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function matchesTopic(article) {
      if (!activeTopic || activeTopic === 'all') return true;
      return (article.topics || []).indexOf(activeTopic) !== -1;
    }

    function matchesQuery(article) {
      var q = normalizeQuery(activeQuery);
      if (!q) return true;
      return article._haystack.indexOf(q) !== -1;
    }

    function filteredArticles() {
      return articles.filter(function (article) {
        if (featuredId && article.id === featuredId && !activeQuery && activeTopic === 'all') {
          return false;
        }
        return matchesTopic(article) && matchesQuery(article);
      });
    }

    function syncFromUrl() {
      var urlState = readUrlState();
      activeTopic = urlState.topic;
      activeQuery = urlState.q;
      visibleLimit = PAGE_SIZE;
      section._learnActiveTopic = activeTopic;
      section._learnActiveQuery = activeQuery;
      if (searchInput) searchInput.value = activeQuery;
      setFilterPressed(activeTopic);
    }

    function updateFeaturedVisibility() {
      if (!featuredRow) return;
      var hide = activeTopic !== 'all' || normalizeQuery(activeQuery) !== '';
      featuredRow.hidden = hide;
      featuredRow.classList.toggle('known-learn__featured-row--hidden', hide);
    }

    function updatePopularDedup() {
      var popularCards = section.querySelectorAll('[data-learn-popular-card]');
      var featuredVisible = featuredRow && !featuredRow.hidden;
      popularCards.forEach(function (card) {
        var id = articleId(card.getAttribute('data-article-id'));
        var hide = featuredVisible && featuredId && id === articleId(featuredId);
        card.hidden = hide;
        card.classList.toggle('is-hidden', hide);
      });
    }

    function announceStatus(count, showing) {
      if (!statusEl) return;
      if (count === 0) {
        statusEl.textContent = '';
        return;
      }
      var parts = [];
      if (normalizeQuery(activeQuery)) {
        parts.push(count + ' result' + (count === 1 ? '' : 's') + ' for “' + activeQuery + '”');
      } else if (activeTopic !== 'all') {
        parts.push(count + ' article' + (count === 1 ? '' : 's') + ' in ' + topicLabel(config, activeTopic));
      } else {
        parts.push(count + ' article' + (count === 1 ? '' : 's'));
      }
      if (showing < count) {
        parts.push('showing ' + showing);
      }
      statusEl.textContent = parts.join(' · ');
    }

    function preserveSsr() {
      grid.querySelectorAll('[data-learn-ssr]').forEach(function (card) {
        card.hidden = false;
        card.classList.remove('is-hidden');
      });
    }

    function degradedMode() {
      preserveSsr();
      updateFeaturedVisibility();
      if (emptyState) emptyState.hidden = true;
      if (loadMoreBtn) loadMoreBtn.hidden = true;
      var ssrCount = grid.querySelectorAll('[data-learn-ssr]:not(.is-hidden)').length;
      if (statusEl) {
        var ssrAttr = statusEl.getAttribute('data-learn-ssr-count');
        var count = ssrAttr ? parseInt(ssrAttr, 10) : ssrCount;
        if (count > 0) announceStatus(count, Math.min(count, PAGE_SIZE));
        else if (!statusEl.textContent) statusEl.textContent = '';
      }
      updatePopularDedup();
      section._learnFilteredCount = null;
    }

    function render() {
      section._learnFilteredCount = indexReady ? filteredArticles().length : null;

      if (!indexReady) {
        degradedMode();
        return;
      }

      var list = filteredArticles();
      var count = list.length;
      var slice = list.slice(0, visibleLimit);
      var ssrCards = grid.querySelectorAll('[data-learn-ssr]');
      var useSsr =
        activeTopic === 'all' &&
        !normalizeQuery(activeQuery) &&
        visibleLimit <= PAGE_SIZE &&
        ssrCards.length > 0 &&
        slice.length > 0;

      updateFeaturedVisibility();

      if (useSsr) {
        var ssrIds = {};
        ssrCards.forEach(function (card) {
          var id = articleId(card.getAttribute('data-article-id'));
          ssrIds[id] = true;
          card.hidden = false;
          card.classList.remove('is-hidden');
        });
        grid.querySelectorAll('[data-learn-card]:not([data-learn-ssr])').forEach(function (node) {
          node.remove();
        });
        slice
          .filter(function (a) {
            return !ssrIds[a.id];
          })
          .forEach(function (article) {
            grid.insertAdjacentHTML('beforeend', renderCard(article, config, labels));
          });
        ssrCards.forEach(function (card) {
          var id = articleId(card.getAttribute('data-article-id'));
          var inSlice = slice.some(function (a) {
            return a.id === id;
          });
          if (!inSlice) {
            card.hidden = true;
            card.classList.add('is-hidden');
          }
        });
      } else if (slice.length > 0) {
        grid.innerHTML = slice
          .map(function (article) {
            return renderCard(article, config, labels);
          })
          .join('');
      } else {
        grid.innerHTML = '';
      }

      var showEmpty = count === 0 && (normalizeQuery(activeQuery) || activeTopic !== 'all');
      if (emptyState) emptyState.hidden = !showEmpty;

      if (loadMoreBtn) {
        loadMoreBtn.hidden = visibleLimit >= count || count === 0;
        loadMoreBtn.disabled = visibleLimit >= count;
      }

      announceStatus(count, Math.min(visibleLimit, count));
      updatePopularDedup();
    }

    function applyState(topic, q, urlReplace) {
      activeTopic = topic || 'all';
      activeQuery = q || '';
      visibleLimit = PAGE_SIZE;
      section._learnActiveTopic = activeTopic;
      section._learnActiveQuery = activeQuery;
      if (searchInput) searchInput.value = activeQuery;
      setFilterPressed(activeTopic);
      writeUrlState(activeTopic, activeQuery, urlReplace);
      render();
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyState(btn.getAttribute('data-learn-filter'), activeQuery, false);
      });
      btn.addEventListener('focus', function () {
        btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
      });
    });

    if (searchInput) {
      section._learnSearchListener = true;
      var searchTimer;
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          applyState(activeTopic, searchInput.value, false);
        }, 250);
      });
      searchInput.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          searchInput.value = '';
          applyState(activeTopic, '', false);
        }
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        if (!indexReady) return;
        visibleLimit += PAGE_SIZE;
        render();
        loadMoreBtn.focus();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        applyState('all', '', false);
        if (searchInput) searchInput.focus();
      });
    }

    window.addEventListener('popstate', function () {
      syncFromUrl();
      render();
    });

    syncFromUrl();
    render();
  }

  function boot() {
    document.querySelectorAll('.known-learn[data-learn-library]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
